export default __webpack_public_path__ + "static/media/html5-brands.7130e06b.svg";